import { StackWrapper } from "../styles";

export interface TimerStackProps {
  totalStack: string;
  avgStack: string;
  players: string;
}

const TimerCommonStack = ({
  totalStack,
  avgStack,
  players,
}: TimerStackProps) => {
  return (
    <StackWrapper>
      <div className="data">
        <div className="title">TOTAL STACKS</div>
        <div className="value">{totalStack}</div>
      </div>
      <div className="line" />
      <div className="data">
        <div className="title">AVG STACKS</div>
        <div className="value">{avgStack}</div>
      </div>
      <div className="line" />
      <div className="data">
        <div className="title">PLAYERS</div>
        <div className="value">{players}</div>
      </div>
    </StackWrapper>
  );
};

export default TimerCommonStack;
